var _g, _path, _g2, _path2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampfirePoints10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 127,
    viewBox: "0 0 99 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4126 118.19C50.4126 118.19 67.1555 116.362 76.4316 109.505C85.7076 102.648 95.8844 89.6181 94.7537 72.2506C93.6231 54.8831 89.3234 50.9946 89.3234 50.9946C89.3234 50.9946 86.6083 61.2812 82.3095 59.4509C78.0108 57.6206 82.0839 35.6852 74.3915 24.9393C66.699 14.1933 47.0145 0.94043 47.0145 0.94043C47.0145 0.94043 52.2183 23.1099 47.0145 26.3102C41.8107 29.5106 34.7968 28.8242 32.5347 33.6244C30.2725 38.4245 30.9546 65.9997 23.2577 65.9997C15.5609 65.9997 14.2082 49.6245 14.2082 49.6245C14.2082 49.6245 3.79969 64.4798 4.25265 75.2213C4.70561 85.9628 18.7369 103.106 18.7369 103.106L11.0444 101.51C11.0444 101.51 23.4842 118.19 50.4126 118.19Z",
    fill: "url(#paint0_radial)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2734 47.093C10.2734 47.093 16.4929 40.3987 17.9202 36.4845C19.3476 32.5703 19.8576 24.0226 19.1439 24.6407C10.9871 31.4378 10.4077 37.851 10.2734 47.093Z",
    fill: "#FF6320"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2352 113.427C44.2352 113.427 57.4483 116.94 68.7495 107.456C75.4157 101.909 81.4256 95.6028 86.66 88.6632L77.6183 90.9484C77.6183 90.9484 77.4427 81.6372 79.7031 76.0177C81.9636 70.3982 82.1365 65.9971 73.0369 72.5185C71.8676 73.3565 63.3596 70.9223 65.4463 56.874C67.5329 42.8257 62.8382 29.2952 55.015 21.2202C55.015 28.9485 37.2827 38.6081 36.4119 52.6582C35.5411 66.7083 34.1656 93.2327 14.8594 73.7343C14.8594 92.5268 29.9792 111.671 44.2352 113.427Z",
    fill: "#FE9A3D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3695 110.618C54.6064 113.319 70.6795 105.378 71.5354 93.932C72.9267 87.4346 72.5791 83.57 68.5806 80.0575C57.749 71.0718 55.6317 46.4593 57.6279 35.8525C36.609 56.0045 50.7904 65.5064 39.0257 79.7072C32.765 84.2732 22.5075 82.5165 21.6385 85.5023C20.7694 88.4881 35.0254 109.915 47.3695 110.618Z",
    fill: "#FFB22D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7676 109.216C59.4661 109.071 66.4984 97.4486 65.1079 91.3032C63.7174 85.1578 54.1561 77.4225 53.4608 70.0463C52.7656 62.67 53.2853 59.5654 53.2853 59.5654C53.2853 59.5654 48.4247 68.6416 46.9429 74.4367C45.4611 80.2318 43.8968 88.4877 40.4197 89.5412C36.9426 90.5947 31.2025 88.4877 32.5956 91.4734C33.9887 94.4592 40.2538 109.388 50.7676 109.216Z",
    fill: "#FFE840"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7659 107.265C57.6192 107.265 60.049 97.6063 59.4258 93.4074C58.8025 89.2085 50.2138 82.2783 50.7659 80.1784C51.3181 78.0786 49.2411 89.8372 45.4989 91.5168C41.7567 93.1963 38.0163 93.8224 39.4709 97.6054C40.9254 101.388 44.5491 107.265 50.7659 107.265Z",
    fill: "#FDFBE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.238281,
    y: 0.94043,
    width: 98.6018,
    height: 125.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.972549 0 0 0 0 0.239216 0 0 0 0 0.121569 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 10.8594,
    y: 19.2202,
    width: 79.8006,
    height: 100.843,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.443137 0 0 0 0 0.231373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 28.3818,
    y: 55.5654,
    width: 40.9022,
    height: 57.6521,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.25098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f",
    x: 36.1494,
    y: 76.9282,
    width: 26.3704,
    height: 33.3368,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.5392 59.5653) rotate(-72.7076) scale(43.7091 35.99)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F87A1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F83D1F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampfirePoints10);
export default __webpack_public_path__ + "static/media/campfire-points-10.30fe397660ab96b2260bcd81a00068b7.svg";
export { ForwardRef as ReactComponent };